import { IAppState } from '../../../AppModulesWrapper';

export const selectPrice = (state: IAppState) => {
  return state.servicePickerWidget.offer.bargainTerms.price;
};
